import { useState } from 'react';
import { useHistory } from 'react-router';

import { requireRole } from '@/helpers/permissions';
import CouponForm from '@/components/CouponForm';
import Page from '@/pages/Page';

export default requireRole(['owner', 'manager'], NewCouponPage);

function NewCouponPage() {
  const history = useHistory();
  const [key, setKey] = useState(() => _.uniqueId('new-coupon-form'));

  const resetForm = () => {
    history.push('/coupons');
    _.delay(() => setKey(_.uniqueId('new-coupon-form')));
  };

  return (
    <Page title="New Coupon" backDefault="/coupons">
      <CouponForm key={key} done={resetForm}/>
    </Page>
  );
}
